"use strict";
/*
 * Created on 01 25 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Jaroslav Sevcik
 */


var SelloutSubSettingsConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SelloutSubSettingsConverter, _DataObjectConverter_);

  function SelloutSubSettingsConverter() {
    _classCallCheck(this, SelloutSubSettingsConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutSubSettingsConverter).apply(this, arguments));
  }

  return SelloutSubSettingsConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SelloutSubSettingsConverter = SelloutSubSettingsConverter;